import { createContext } from "react";

export interface FeatureAppConfig {
  globalApi: string;
  secretBaseUrl?: string;
  pageBaseUrl?: {
    author: {
      en: string;
      fr: string;
    },
    dispatcher: {
      en: string;
      fr: string;
    }
  },
  PEFA?: string,
  PEFS?: string,
  SOFA?: string,
  motoCommerceScript?: string
  baseUrls?: {
    PEFA: string,
    PEFS: string,
    SOFA: string,
  },
  BATD?: {
    en: string;
    fr: string;
  }
};

export const AppContext = createContext<FeatureAppConfig>({
  globalApi: "https://globalapi.vwtools.ca"
});
